import axios from 'axios';
import { authHeader } from './authservice/auth-header';

// const ELASTIC_API = process.env.VUE_APP_ELASTIC_API;
const BASE_API = process.env.VUE_APP_BASE_API_URL;

class AdvancedService {
    searchSocmed(ip, data) {
        return axios.post(ip+'facebook/_search?scroll=10m', data, { headers: {'Content-Type': 'application/json'} });
    }
    searchEcomm(ip, data) {
        return axios.post(ip+'tokopedia/_search?scroll=10m', data, { headers: {'Content-Type': 'application/json'} });
    }
    // searchEmailTokped(data) {
    //     return axios.post(ELASTIC_API + 'tokopedia/_search', data, { headers: {'Content-Type': 'application/json'} });
    // }
    saveSocmed(data) {
        return axios.post(BASE_API + 'advanced-search/socmed', data, { headers: authHeader() });
    }
    updateSocmed(id, data) {
        return axios.patch(BASE_API + 'advanced-search/socmed/'+id, data, { headers: authHeader() });
    }
    saveEcomm(data) {
        return axios.post(BASE_API + 'advanced-search/ecomm', data, { headers: authHeader() });
    }
    updateEcomm(id, data) {
        return axios.patch(BASE_API + 'advanced-search/ecomm/'+id, data, { headers: authHeader() });
    }
    saveBreach(data) {
        return axios.post(BASE_API + 'breach-checker', data, { headers: authHeader() });
    }
    getBreach(id) {
        return axios.get(BASE_API + 'breach-checker-target/'+id, { headers: authHeader() });
    }
    deleteFB(id){
        return axios.delete(BASE_API + 'advanced-search/socmed/'+id, { headers: authHeader() });
    }
    deleteTokped(id){
        return axios.delete(BASE_API + 'advanced-search/ecomm/'+id, { headers: authHeader() });
    }
}

export default new AdvancedService();


